import { Tooltip } from 'shared-ui';

import { ReactComponent as ReturnIcon } from 'assets/icons/refresh-primary.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { ReturnMultiCardsProps } from './ReturnMultiCards.types';
import * as Styled from './ReturnMultiCards.styles';

export const ReturnMultiCards = ({
  checkedCards,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: ReturnMultiCardsProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isDisabled = !perms?.[Functionality.KARTY_POSIADACZE]?.edit;

  return (
    <>
      <Tooltip title={formatMessage({ id: AppMessages['common.noPermissions'] })} disableHoverListener={!isDisabled}>
        <Styled.ReturnButton
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={<ReturnIcon />}
          onClick={onModalOpen}
          disabled={isDisabled}
        >
          {formatMessage({ id: AppMessages['cards.multiAction.return.button'] })}
        </Styled.ReturnButton>
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['cards.multiAction.return.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        submitButtonDisabled={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['cards.multiAction.return.actionButton'] })}
      >
        <>
          <ActionModal.Subtitle>
            {formatMessage({ id: AppMessages['cards.multiAction.return.subtitle'] })} {checkedCards.length}
          </ActionModal.Subtitle>

          <ActionModal.Text>{formatMessage({ id: AppMessages['cards.multiAction.return.text'] })}</ActionModal.Text>

          <ActionModal.Text>{formatMessage({ id: AppMessages['common.reversibleAction'] })}</ActionModal.Text>
        </>
      </ActionModal>
    </>
  );
};
